import React, { useEffect, useState } from 'react';
import { getTrainerResults, queryEquipment, setBash, setCharge, setAttack, setHide, setKick, setOpponentDb, setOpponentLevel, setOpponentNotice, setOpponentOb, setOpponentPb, setSneak, setSortWeapons, setStab, setWeaponType, applyArmorSet, applyTrinketSet, setWeaponHands, removeAll, clearFilters, setOpponentWeaponWeight, applyOpponentBuild, setNotice, setOpponentClubs, setOpponentSat, setSortArmor } from './equipmentTrainerSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button, CloseButton, Dropdown, FormSelect, Offcanvas, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NumberInput from '../common/NumberInput';
import { WornSelect } from './WornSelect';
import FractionalInput from '../common/FractionalInput';

function EquipmentTrainerMain() {
  const dispatch = useAppDispatch();
  const sortWeapons = useAppSelector(x => x.equipmentTrainer.sortWeapons);
  const sortArmor = useAppSelector(x => x.equipmentTrainer.sortArmor);
  const equipment = useAppSelector(x => x.equipmentTrainer.equipment).filter(x => x.weight && !x.setup.includes('horse'));
  const weaponType = useAppSelector(x => x.equipmentTrainer.weaponType);
  const weaponHands = useAppSelector(x => x.equipmentTrainer.weaponHands);
  const bash = useAppSelector(x => x.equipmentTrainer.bash);
  const kick = useAppSelector(x => x.equipmentTrainer.kick);
  const stab = useAppSelector(x => x.equipmentTrainer.stab);
  const hide = useAppSelector(x => x.equipmentTrainer.hide);
  const sneak = useAppSelector(x => x.equipmentTrainer.sneak);
  const notice = useAppSelector(x => x.equipmentTrainer.notice);
  const charge = useAppSelector(x => x.equipmentTrainer.charge);
  const attack = useAppSelector(x => x.equipmentTrainer.attack);
  const mountedDisabled = useAppSelector(x => x.equipmentTrainer.mountedDisabled);
  const opponentLevel = useAppSelector(x => x.equipmentTrainer.opponentLevel);
  const opponentOb = useAppSelector(x => x.equipmentTrainer.opponentOb);
  const opponentDb = useAppSelector(x => x.equipmentTrainer.opponentDb);
  const opponentPb = useAppSelector(x => x.equipmentTrainer.opponentPb);
  const opponentNotice = useAppSelector(x => x.equipmentTrainer.opponentNotice);
  const opponentWeaponWeight = useAppSelector(x => x.equipmentTrainer.opponentWeaponWeight);
  const opponentClubs = useAppSelector(x => x.equipmentTrainer.opponentClubs);
  const opponentSat = useAppSelector(x => x.equipmentTrainer.opponentSat);
  const ob = useAppSelector(x => x.equipmentTrainer.ob);
  const db = useAppSelector(x => x.equipmentTrainer.db);
  const pb = useAppSelector(x => x.equipmentTrainer.pb);
  const abs = useAppSelector(x => x.equipmentTrainer.abs);
  const damage = useAppSelector(x => x.equipmentTrainer.damage);
  const weaponWeight = useAppSelector(x => x.equipmentTrainer.weaponWeight);
  const totalWeight = useAppSelector(x => x.equipmentTrainer.totalWeight);
  const bashChance = useAppSelector(x => x.equipmentTrainer.bashChance);
  const opponentBashChance = useAppSelector(x => x.equipmentTrainer.opponentBashChance);
  const kickChance = useAppSelector(x => x.equipmentTrainer.kickChance);
  const opponentKickChance = useAppSelector(x => x.equipmentTrainer.opponentKickChance);
  const strn = useAppSelector(x => x.equipmentTrainer.strn);
  const mvs = useAppSelector(x => x.equipmentTrainer.mvs);
  const hitChance = useAppSelector(x => x.equipmentTrainer.hitChance);
  const opponentHitChance = useAppSelector(x => x.equipmentTrainer.opponentHitChance);
  const chargeChance = useAppSelector(x => x.equipmentTrainer.chargeChance);
  const opponentChargeChance = useAppSelector(x => x.equipmentTrainer.opponentChargeChance);
  const stabChance = useAppSelector(x => x.equipmentTrainer.stabChance);
  const opponentStabChance = useAppSelector(x => x.equipmentTrainer.opponentStabChance);
  const attackChance = useAppSelector(x => x.equipmentTrainer.attackChance);

  const groupWeapons = false;
  let weaponData = equipment.filter(x => x.type === 'weapon');
  let armorData = equipment.filter(x => x.type !== 'weapon');
  
  const weaponTypeKeys = weaponData.reduce((acc, val) => {
    if (!acc.includes(val.weaponType)) {
      acc.push(val.weaponType);
    }
    return acc;
  }, [] as string[]).sort();

    function round(value: number) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  const weaponTypeOptions = weaponTypeKeys.map(x => {
    let label: string;
    if (x === 'staff') {
      label = 'Staves';
    } else {
      label = x.replace(/\b([a-z])/g, x => x.toUpperCase()) + 's';
    }
    return {
      label,
      value: x
    };
  });

  if (weaponType) {
    weaponData = weaponData.filter(x => x.weaponType === weaponType);
  }

  if (weaponHands) {
    weaponData = weaponData.filter(x => Math.floor(x.weaponHands) === weaponHands);
  }

  if (strn) {
    const value = strn < 17 ? strn : strn + 1;
    weaponData = weaponData.filter(x => x.weight <= value);
  }

  if (sortWeapons === 'ob') {
    weaponData.sort((a, b) => b.ob - a.ob);
  } else if (sortWeapons === 'pb') {
    weaponData.sort((a, b) => b.pb - a.pb);
  } else if (sortWeapons === 'weight') {
    weaponData.sort((a, b) => b.weight - a.weight);
  } else if (sortWeapons === 'damage') {
    weaponData.sort((a, b) => b.meanDamage - a.meanDamage);
  }

  if (sortArmor === 'db') {
    armorData.sort((a, b) => b.db !== a.db ? b.db - a.db : b.pb - a.pb);
  } else if (sortArmor === 'pb') {
    armorData.sort((a, b) => b.pb !== a.pb ? b.pb - a.pb : b.db - a.db);
  } else if (sortArmor === 'def') {
    armorData.sort((a, b) => (b.db + b.pb) !== (a.db + a.pb) ? (b.db + b.pb) - (a.db + a.pb) : (b.weight !== a.weight ? a.weight - b.weight : b.db - a.db));
  } else if (sortArmor === 'abs') {
    armorData.sort((a, b) => b.abs !== a.abs ? b.abs - a.abs : b.mvs - a.mvs);
  } else if (sortArmor === 'mvs') {
    armorData.sort((a, b) => b.mvs !== a.mvs ? b.mvs - a.mvs : b.abs - a.abs);
  } else if (sortArmor === 'weight') {
    armorData.sort((a, b) => b.weight - a.weight);
  }
  
  const fingerOptions = armorData.filter(x => x.slot === 'finger').map(x => ({
    value: x.name,
    label: x.name
  }));

  const headOptions = armorData.filter(x => x.slot === 'head').map(x => ({
    value: x.name,
    label: x.name
  }));

  const neckOptions = armorData.filter(x => x.slot === 'neck').map(x => ({
    value: x.name,
    label: x.name
  }));

  const bodyOptions = armorData.filter(x => x.slot === 'body').map(x => ({
    value: x.name,
    label: x.name
  }));

  const cloakOptions = armorData.filter(x => x.slot === 'cloak').map(x => ({
    value: x.name,
    label: x.name
  }));

  const sheathOptions = armorData.filter(x => x.slot === 'back' || x.slot === 'sheath').map(x => ({
    value: x.name,
    label: x.name
  }));

  const armsOptions = armorData.filter(x => x.slot === 'arms').map(x => ({
    value: x.name,
    label: x.name
  }));
  
  const handsOptions = armorData.filter(x => x.slot === 'hands').map(x => ({
    value: x.name,
    label: x.name
  }));

  const wristOptions = armorData.filter(x => x.slot === 'wrist').map(x => ({
    value: x.name,
    label: x.name
  }));
  
  const shieldOptions = armorData.filter(x => x.slot === 'shield').map(x => ({
    value: x.name,
    label: x.name
  }));

  const waistOptions = armorData.filter(x => x.slot === 'waist').map(x => ({
    value: x.name,
    label: x.name
  }));

  const legsOptions = armorData.filter(x => x.slot === 'legs').map(x => ({
    value: x.name,
    label: x.name
  }));

  const feetOptions = armorData.filter(x => x.slot === 'feet').map(x => ({
    value: x.name,
    label: x.name
  }));

  let weaponOptions: any[] = [];
  if (!groupWeapons) {
    weaponOptions = weaponData.filter(x => x.type === 'weapon').map(x => ({
      value: x.name,
      label: x.name + ` (${x.weaponHands}h)`
    }));
  } else {
    const weaponGroups = weaponData.filter(x => x.type === 'weapon')
      .reduce((acc: any, val) => {
        const key = val.weaponType;
        acc[key] = acc[key] || [];
        acc[key].push(val);
        return acc;
      }, {});

    for (let key of Object.keys(weaponGroups).sort()) {
      const value = weaponGroups[key];
      weaponOptions.push({
        label: key === 'staff' ? 'staves' : key + 's',
        options: value.map((x: any) => ({ value: x.name, label: x.name + ` (${x.weaponHands}h)`}))
      });
    }
  }

  for (let options of [
    fingerOptions,
    headOptions,
    neckOptions,
    bodyOptions,
    cloakOptions,
    sheathOptions,
    armsOptions,
    wristOptions,
    handsOptions,
    shieldOptions,
    weaponOptions,
    waistOptions,
    legsOptions,
    feetOptions]) {
    options.unshift({value: '_', label: '- nothing -'}); 
  }

  useEffect(() => {
    (async () =>{
      await dispatch(queryEquipment());
    })();
  }, [dispatch]);

  const handleOpponentBuildClick = (value: string) => {
    dispatch(applyOpponentBuild(value));
    dispatch(getTrainerResults());
  }

  const handleRemoveAllClick = () => {
    dispatch(removeAll());
    dispatch(getTrainerResults());
  }

  const handleWeaponTypeChange = (value: string) => {
    dispatch(setWeaponType(value));
    dispatch(getTrainerResults());
  }

  const handleWeaponHandsChange = (value: string) => {
    dispatch(setWeaponHands(parseInt(value, 10)));
    dispatch(getTrainerResults());
  }

  const handleSortWeaponsChange = (value: string) => {
    dispatch(setSortWeapons(value));
    dispatch(getTrainerResults());
  }

  const handleSortArmorChange = (value: string) => {
    dispatch(setSortArmor(value));
    dispatch(getTrainerResults());
  }

  const handleBashChange = (value: number) => {
    dispatch(setBash(value));
    dispatch(getTrainerResults());
  }

  const handleKickChange = (value: number) => {
    dispatch(setKick(value));
    dispatch(getTrainerResults());
  }

  const handleStabChange = (value: number) => {
    dispatch(setStab(value));
    dispatch(getTrainerResults());
  }

  const handleHideChange = (value: number) => {
    dispatch(setHide(value));
    dispatch(getTrainerResults());
  }

  const handleSneakChange = (value: number) => {
    dispatch(setSneak(value));
    dispatch(getTrainerResults());
  }

  const handleNoticeChange = (value: number) => {
    dispatch(setNotice(value));
    dispatch(getTrainerResults());
  }

  const handleChargeChange = (value: number) => {
    dispatch(setCharge(value));
    dispatch(getTrainerResults());
  } 

  const handleAttackChange = (value: number) => {
    dispatch(setAttack(value));
    dispatch(getTrainerResults());
  }

  const handleOpponentLevelChange = (value: number) => {
    dispatch(setOpponentLevel(value));
    dispatch(getTrainerResults());
  }

  const handleOpponentObChange = (value: number) => {
    dispatch(setOpponentOb(value));
    dispatch(getTrainerResults());
  }

  const handleOpponentDbChange = (value: number) => {
    dispatch(setOpponentDb(value));
    dispatch(getTrainerResults());
  }
  
  const handleOpponentPbChange = (value: number) => {
    dispatch(setOpponentPb(value));
    dispatch(getTrainerResults());
  }
    
  const handleOpponentNoticeChange = (value: number) => {
    dispatch(setOpponentNotice(value));
    dispatch(getTrainerResults());
  }

  const handleOpponentWeaponWeightChange = (value: number) => {
    dispatch(setOpponentWeaponWeight(value));
    dispatch(getTrainerResults());
  }

  const handleOpponentClubsChange = (value: boolean) => {
    dispatch(setOpponentClubs(value));
    dispatch(getTrainerResults());
  }

  const handleOpponentSatChange = (value: boolean) => {
    dispatch(setOpponentSat(value));
    dispatch(getTrainerResults());
  }

  const handleArmorSetClick = (value: string) => {
    dispatch(applyArmorSet(value));
    dispatch(getTrainerResults());
  }

  const handleTrinketSetClick = (value: string) => {
    dispatch(applyTrinketSet(value));
    dispatch(getTrainerResults());
  }

  const [showOffCanvas, setShowOffCanvas] = useState(false);

  const handleShowOffCanvas = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    setShowOffCanvas(true);
  }

  const handleCloseOffCanvas = () => {
    setShowOffCanvas(false);
  }

  const anyFilters = weaponType || weaponHands || sortWeapons || sortArmor;

  return (
    <div className="skill-list equipmenttrainer-frame">
      <div className="row g-0">
        <div className="column col-12">
          <div className="cell">
            <div className="group-title">
              <h6 className="me-3 my-0">EQUIPMENT</h6>
              <a className="text-decoration-none" href="/#" onClick={(e) => handleShowOffCanvas(e)}>Options</a>
              {anyFilters ? <CloseButton className="ms-2" style={{fontSize: '.6125rem'}} onClick={() => dispatch(clearFilters())}/> : null}
            </div>
            <div className="group-list px-0 row gx-5">
              {/* LEFT */}
              <div className="col-lg-6 py-2 pb-0">
                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on finger</div>
                  <WornSelect placeholder="finger" slot="finger1" options={fingerOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on finger</div>
                  <WornSelect placeholder="finger" slot="finger2" options={fingerOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on head</div>
                  <WornSelect placeholder="head" slot="head" options={headOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn around neck</div>
                  <WornSelect placeholder="neck" slot="neck1" options={neckOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn around neck</div>
                  <WornSelect placeholder="neck" slot="neck2" options={neckOptions} />
                </div>              

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on body</div>
                  <WornSelect placeholder="body" slot="body" options={bodyOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn about body</div>
                  <WornSelect placeholder="cloak" slot="cloak" options={cloakOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">slung on back</div>
                  <WornSelect placeholder="sheath" slot="sheath" options={sheathOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on arms</div>
                  <WornSelect placeholder="arms" slot="arms" options={armsOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on hands</div>
                  <WornSelect placeholder="hands" slot="hands" options={handsOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn around wrist</div>
                  <WornSelect placeholder="wrist" slot="wrist1" options={wristOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn around wrist</div>
                  <WornSelect placeholder="wrist" slot="wrist2" options={wristOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn as shield</div>
                  <WornSelect placeholder="shield" slot="shield" options={shieldOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">wielded</div>
                  <WornSelect placeholder="wielded" slot="wielded" options={weaponOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn about waist</div>
                  <WornSelect placeholder="waist" slot="waist" options={waistOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on legs</div>
                  <WornSelect placeholder="legs" slot="legs" options={legsOptions} />
                </div>

                <div className="eqtrainer-row">
                  <div className="eqtrainer-slot d-none d-xxl-block">worn on feet</div>
                  <WornSelect placeholder="feet" slot="feet" options={feetOptions} />
                </div>

                <div className="eqtrainer-row mt-2">
                  <div className="eqtrainer-slot d-none d-xxl-block"></div>
                  <div className="d-flex flex-wrap">
                    <Dropdown>
                      <Dropdown.Toggle className="small-button me-2 mb-2">
                        Armor Sets
                      </Dropdown.Toggle>
                      <Dropdown.Menu style={{fontSize: '.75rem'}}>
                        <Dropdown.Header>ABS</Dropdown.Header>
                        <Dropdown.Item onClick={() => handleArmorSetClick('abs_standard')}>ABS - Standard</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleArmorSetClick('abs_murgoz')}>ABS - Murgoz</Dropdown.Item>
                        <Dropdown.Header>Combo</Dropdown.Header>
                        <Dropdown.Item onClick={() => handleArmorSetClick('combo_standard')}>Combo - Standard</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleArmorSetClick('combo_gold')}>Combo - Gold</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleArmorSetClick('combo_rare')}>Combo - Rare</Dropdown.Item>
                        <Dropdown.Header>Dodge</Dropdown.Header>
                        <Dropdown.Item onClick={() => handleArmorSetClick('dodge_standard')}>Dodge - Standard</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleArmorSetClick('dodge_rare')}>Dodge - Rare</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown>
                      <Dropdown.Toggle className="small-button me-2 mb-2">
                        Trinket Sets
                      </Dropdown.Toggle>
                      <Dropdown.Menu style={{fontSize: '.75rem'}}>
                        <Dropdown.Header>ABS</Dropdown.Header>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('abs_standard')}>ABS - Standard</Dropdown.Item>
                        {/*<Dropdown.Item onClick={() => handleTrinketSetClick('abs_moves')}>ABS - Moves</Dropdown.Item>*/}
                        <Dropdown.Header>Combo</Dropdown.Header>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('combo_standard')}>Combo - Standard</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('combo_mixed')}>Combo - Mixed</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('combo_rare')}>Combo - Rare</Dropdown.Item>
                        <Dropdown.Header>Dodge</Dropdown.Header>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('dodge_basic')}>Dodge - Basic</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('dodge_standard')}>Dodge - Standard</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleTrinketSetClick('dodge_rare')}>Dodge - Rare</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Button className="small-button mb-2" size="sm" style={{width: '80px'}} onClick={() => handleRemoveAllClick()}>Remove All</Button>
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-lg-6 py-2 pb-2 mt-4 mt-lg-0" style={{fontSize: ".75rem"}}>
                <h6 className="special mt-0">MORE SKILLS</h6>
                <div className="d-flex flex-wrap">
                  <div className="me-2">
                    <label className="small-label">Bash</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={bash || null}
                      onNumberChange={e => handleBashChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Kick</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={kick || null}
                      onNumberChange={e => handleKickChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Charge</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={charge || null}
                      onNumberChange={e => handleChargeChange(e ?? 0)}
                      disabled={mountedDisabled}
                      placeholder="%"/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Stab</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={stab || null}
                      onNumberChange={e => handleStabChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Hide</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={hide || null}
                      onNumberChange={e => handleHideChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Sneak</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={sneak || null}
                      onNumberChange={e => handleSneakChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Notice</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={notice || null}
                      onNumberChange={e => handleNoticeChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div>
                    <label className="small-label">Attack</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={attack || null}
                      onNumberChange={e => handleAttackChange(e ?? 0)}
                      placeholder="%"/>
                  </div>

                </div>

                <Dropdown className="mt-5 special">
                    <Dropdown.Toggle>
                      OPPONENT
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{fontSize: '.75rem'}}>
                      <Dropdown.Header>ABS</Dropdown.Header>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('abs_warrior_common')}>ABS Warrior - Common</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('abs_warrior_elite')}>ABS Warrior - Elite</Dropdown.Item>
                      <Dropdown.Header>Combo</Dropdown.Header>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('combo_hunter_common')}>Combo Hunter - Common</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('combo_hunter_elite')}>Combo Hunter - Elite</Dropdown.Item>
                      <Dropdown.Header>Dodge</Dropdown.Header>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('dodge_rogue_common')}>Dodge Rogue - Common</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('dodge_rogue_elite')}>Dodge Rogue - Elite</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('dodge_channeler_common')}>Dodge Channeler - Common</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleOpponentBuildClick('dodge_channeler_elite')}>Dodge Channeler - Elite</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                <div className="d-flex align-items-center flex-wrap">
                  <div className="me-2">
                    <label className="small-label">Level</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={999} numberValue={opponentLevel || null}
                      onNumberChange={e => handleOpponentLevelChange(e ?? 0)}
                      placeholder=""/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">OB</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={999} numberValue={opponentOb || null}
                      onNumberChange={e => handleOpponentObChange(e ?? 0)}
                      placeholder=""/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">DB</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={999} numberValue={opponentDb || null}
                      onNumberChange={e => handleOpponentDbChange(e ?? 0)}
                      placeholder=""/>
                  </div>
                  <div className="me-2">
                    <label className="small-label">PB</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={999} numberValue={opponentPb || null}
                      onNumberChange={e => handleOpponentPbChange(e ?? 0)}
                      placeholder=""/>
                  </div>
                  <div className="me-2" style={{width: '124px'}}>
                    <label className="small-label">Weapon LB</label>
                    <div className="d-flex align-items-center">
                      <FractionalInput
                        className="small-button me-2"
                        style={{width: '58px', fontSize: '.75rem'}}
                        size="sm" min={0} max={99} numberValue={opponentWeaponWeight || null}
                        onNumberChange={e => handleOpponentWeaponWeightChange(e ?? 0)}
                        placeholder=""/>
                      <input id="opponent-club" className="mt-0 form-check-input me-1" type="checkbox" style={{fontSize: '.9rem'}} checked={opponentClubs} onChange={e => handleOpponentClubsChange(e.target.checked)}/>
                      <label htmlFor="opponent-club" className="fw-normal">Clubs</label>
                    </div>
                  </div>
                  <div className="me-2">
                    <label className="small-label">Notice</label>
                    <NumberInput
                      className="small-button"
                      style={{width: '58px', fontSize: '.75rem'}}
                      size="sm" min={0} max={99} numberValue={opponentNotice || null}
                      onNumberChange={e => handleOpponentNoticeChange(e ?? 0)}
                      placeholder="%"/>
                  </div>
                  <div>
                    <label className="small-label">&nbsp;</label>
                    <div className="d-flex align-items-center">
                      <input id="opponent-sat" className="mt-0 form-check-input me-1" type="checkbox" style={{fontSize: '.9rem'}} checked={opponentSat} onChange={e => handleOpponentSatChange(e.target.checked)}/>
                      <label htmlFor="opponent-sat" className="fw-normal">Sat</label>
                    </div>
                  </div>
                </div>

                <h6 className="special mt-5">RESULTS</h6>
                <div className="eqtrainer-results">
                  <div className="row g-0">
                    <div className="col-3">OB</div>
                    <div className="col">{ob}</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">DB</div>
                    <div className="col">{db}</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">PB</div>
                    <div className="col">{pb}</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Defense</div>
                    <div className="col">{db+pb}</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">ABS</div>
                    <div className="col">{abs}%</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">MVS</div>
                    <div className="col">{mvs}</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">Weapon Weight</div>
                    <div className="col">{weaponWeight}</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Total Weight</div>
                    <div className="col">{totalWeight}</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">Damage</div>
                    <div className="col d-flex">
                      <OverlayTrigger placement='right' overlay={
                        <Tooltip style={{position: 'fixed'}}>
                          {damage.slice(1).map((x, i) => <div key={i}>{i ? '+' : ''}{x.damage} ({x.name})</div>)}
                        </Tooltip>}>
                        <div>{damage[0].damage}</div>
                      </OverlayTrigger>
                    </div>

                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Mean Damage</div>
                    <div className="col">{damage[0].mean || 0}</div>
                   
                    {/*<div className="w-100 d-md-none"></div>
                    <div className="col-3">Std Dev Damage</div>
                    <div className="col">{damage[0].stdev || 0}</div>*/}
                  </div>
                  {/*<div className="row g-0">
                    <div className="col-3">Damage</div>
                    <div className="col col-auto">
                      <OverlayTrigger placement='right' overlay={
                        <Tooltip style={{position: 'fixed'}}>
                          {damage.slice(1).map((x, i) => <div key={i}>{i ? '+' : ''}{x.damage} ({x.name})</div>)}
                        </Tooltip>}>
                        <div>{damage[0].damage}</div>
                      </OverlayTrigger>
                    </div>
                  </div>*/}
                  {attack ? <div className="row g-0">
                    <div className="col-3">Hits per Round /w Attack</div>
                    <div className="col">{attackChance}</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Mean Damage /w Attack</div>
                    <div className="col">{round((damage[0].mean || 0) * attackChance)}</div>
                  </div> : null}

                  <div className="row g-0 mt-4">
                    <div className="col-3">You hit opponent</div>
                    <div className="col">{hitChance}%</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Opponent hits you</div>
                    <div className="col">{opponentHitChance}%</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">You bash opponent</div>
                    <div className="col">{bashChance}%</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Opponent bashes you</div>
                    <div className="col">{opponentBashChance}%</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">You kick opponent</div>
                    <div className="col">{kickChance}%</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Opponent kicks you</div>
                    <div className="col">{opponentKickChance}%</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">You charge opponent</div>
                    <div className="col">{chargeChance}%</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Opponent charges you</div>
                    <div className="col">{opponentChargeChance}%</div>
                  </div>
                  <div className="row g-0">
                    <div className="col-3">You stab opponent</div>
                    <div className="col">{stabChance}%</div>
                    <div className="w-100 d-md-none"></div>
                    <div className="col-3">Opponent stabs you</div>
                    <div className="col">{opponentStabChance}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Offcanvas show={showOffCanvas} onHide={() => handleCloseOffCanvas()} style={{fontSize: '1rem'}}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Options</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="mb-2">
            <label className="small-label">Filter Weapon Type</label>
            <FormSelect size="sm"  value={weaponType} onChange={e => handleWeaponTypeChange(e.target.value)}>
              <option value="">All</option>
              {weaponTypeOptions.map(x => <option key={x.value} value={x.value}>{x.label}</option>)}
            </FormSelect>
          </div>
          <div className="mb-2">
            <label className="small-label">Filter Weapon Hands</label>
            <FormSelect size="sm"  value={weaponHands} onChange={e => handleWeaponHandsChange(e.target.value)}>
              <option value="0">Any</option>
              <option value="1">1</option>
              <option value="2">2</option>
            </FormSelect>
          </div>
          <div className="mb-2">
            <label className="small-label">Sort Weapons By</label>
            <FormSelect size="sm" value={sortWeapons} onChange={e => handleSortWeaponsChange(e.target.value)}>
              <option value="">Name</option>
              <option value="damage">Damage</option>
              <option value="ob">OB</option>
              <option value="pb">PB</option>
              <option value="weight">Weight</option>
            </FormSelect>
          </div>
          <div>
            <label className="small-label">Sort Armor &amp; Trinkets By</label>
            <FormSelect size="sm" value={sortArmor} onChange={e => handleSortArmorChange(e.target.value)}>
              <option value="">Name</option>
              <option value="db">DB</option>
              <option value="pb">PB</option>
              <option value="def">Defense</option>
              <option value="abs">ABS</option>
              <option value="mvs">MVS</option>
              <option value="weight">Weight</option>
            </FormSelect>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default EquipmentTrainerMain;
